export default function Footer() {
  const quickLinks = [
    { label: '吃瓜问答', href: '#faq' },
    { label: '精选瓜文', href: '#cards' },
    { label: '话题热榜', href: '#topics' },
    { label: '吃瓜快讯', href: '#updates' },
    { label: '实时热搜', href: '#ranking' },
    { label: '瓜料索引', href: '#index' },
  ];

  return (
    <footer id="footer" className="bg-foreground-950 text-foreground-200 pt-14 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-12">
          <div className="lg:col-span-1">
            <span className="text-2xl font-heading text-white block mb-4 whitespace-nowrap">
              吃瓜官网
            </span>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              51吃瓜官网在线 — 全网最新吃瓜资讯平台。今日吃瓜、实时八卦、本周热门瓜一网打尽，新鲜瓜料每日更新。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading text-white mb-4">快速导航</h4>
            <div className="grid grid-cols-2 gap-2">
              {quickLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading text-white mb-4">热门关键词</h4>
            <div className="flex flex-wrap gap-2">
              {['今日吃瓜', '实时八卦', '最新八卦', '本周热门瓜', '新鲜瓜料', '吃瓜网站'].map(
                (kw) => (
                  <span
                    key={kw}
                    className="inline-flex items-center px-3 py-1 rounded-full bg-foreground-800 text-xs text-foreground-300 whitespace-nowrap cursor-default"
                  >
                    {kw}
                  </span>
                ),
              )}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading text-white mb-4">合作伙伴</h4>
            <div className="space-y-2">
              <p className="text-sm text-foreground-400">
                更多合作伙伴即将入驻，敬请期待。
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            &copy; 2026 吃瓜官网 - 51吃瓜官网在线。本站为娱乐资讯聚合平台，内容仅供参考。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500 cursor-default whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-foreground-500 cursor-default whitespace-nowrap">用户协议</span>
            <span className="text-xs text-foreground-500 cursor-default whitespace-nowrap">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}